import Vendor from "./vendor";

export default Vendor;
